import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialMonitoringIssueState: Dtos.MonitoringIssue & IRegistrationFormState = {
    id: null,
    monitoringId: null,
    monitoring: null,
    monitoringIssueTypeId: null,
    monitoringIssueType: null,
    monitoringIssueDeviationTypeId: null,
    monitoringIssueDeviationType: null,
    monitoringIssueCategoryId: null,
    monitoringIssueCategory: null,
    comments: null,
    correctiveAction: null,
    monitoringIssueExecutiveInformedId: null,
    monitoringIssueExecutiveInformed: null,
    executiveInformedDate: null,
    monitoringIssueActionTakenId: null,
    monitoringIssueActionTaken: null,
    monitoringIssueNotifiedId: null,
    monitoringIssueNotified: null,
    notifiedDate: null,
    monitoringIssueStatusId: null,
    monitoringIssueStatus: null,
    closedDate: null,
    patient: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface IMonitoringIssueReduxFormState {
    id: IFieldState<number>,
    monitoringId: IFieldState<number>,
    monitoring: IFieldState<Dtos.Monitoring>,
    monitoringIssueTypeId: IFieldState<number>,
    monitoringIssueType: IFieldState<Dtos.MonitoringIssueType>,
    monitoringIssueDeviationTypeId: IFieldState<number>,
    monitoringIssueDeviationType: IFieldState<Dtos.MonitoringIssueDeviationType>,
    monitoringIssueCategoryId: IFieldState<number>,
    monitoringIssueCategory: IFieldState<Dtos.MonitoringIssueCategory>,
    comments: IFieldState<string>,
    correctiveAction: IFieldState<string>,
    monitoringIssueExecutiveInformedId: IFieldState<number>,
    monitoringIssueExecutiveInformed: IFieldState<Dtos.MonitoringIssueExecutiveInformed>,
    executiveInformedDate: IFieldState<string>,
    monitoringIssueActionTakenId: IFieldState<number>,
    monitoringIssueActionTaken: IFieldState<Dtos.MonitoringIssueActionTaken>,
    monitoringIssueNotifiedId: IFieldState<number>,
    monitoringIssueNotified: IFieldState<Dtos.MonitoringIssueNotified>,
    notifiedDate: IFieldState<string>,
    monitoringIssueStatusId: IFieldState<number>,
    monitoringIssueStatus: IFieldState<Dtos.MonitoringIssueStatus>,
    closedDate: IFieldState<string>,
    patient: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    saveAndReturn: IFieldState<boolean>,
}
